import React, { Component } from "react";
import Table from "react-bootstrap/Table";
import { Row, Col } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { OrderRequestFiles } from "../../request-details-files.component";
import { RequestOnBehalfDetails } from "../../request-on-behalf-details.component";
import Translation from "../../../../../common/translation/translation.component";
import Icons from '../../../../../icon';
import { ORDER_STATUS } from '../../../../../../constants/external-constants';

class PortInDetails extends Component {
    constructor(props) {
        super(props);
    }
 
    handleShow = () => {
        this.setState({
            show: true
        });
    }

    editRequest = (orderStatusId, endUserId, requestorId, path) => {
        const editableRequest = (orderStatusId === ORDER_STATUS.waitingForAuthorization || orderStatusId === ORDER_STATUS.open);

        var employeeId = sessionStorage.getItem('EmployeeID');
        const isRequestOwner = (endUserId == employeeId) || (requestorId == employeeId);

        return editableRequest && isRequestOwner && !path;
    }

    render() {
        const { data, isWireline, openRequestModal, path } = this.props;
        const { Order: { RequestType: { RequestTypeID, RequestType }, OrderStatusId, EndUserId, RequestorId }} = data || {};
        return (
            <div>               
                <h4 className="order-detail-title"><Translation translationKey="order_request_details" />
                    {this.editRequest(OrderStatusId, EndUserId, RequestorId, path) ?  
                              <Icons
                              customClassName="pen-to-square"
                              name="pen-to-square"
                              size="20px"
                              containerClass="icon-circle-plus-container"
                              onClick={() =>{openRequestModal(RequestTypeID, RequestType)}} 
                              labelValue={"Update Order Request"}
                              labelClass="order-detail-edit-label"                                                              
                          />

                            : null 
                    }
                </h4>
                <div className="order-detail-location">
                    <div className="order-number-container">
                        <h5 className="order-detail-location-title"><Translation translationKey="order_number" /></h5>
                        <span className="order-number-details">{data.Order.OrderNumber}</span>
                    </div>

                    <RequestOnBehalfDetails robDetails={data.RequestedInBeHalfOf} isRob={data.Order.IsRequestedInBehalf} />

                    <h5 className="order-detail-location-title"><Translation translationKey="capital_location" /></h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="country" /></td>
                                {data.BillingAddress.LocationId > 0 ? <td>{data.BillingAddress.CountryName}</td> : null}
                                {data.BillingAddress.OtherDeliveryAddressId > 0 ? <td>{data.OtherLocationCountry}</td> : null}
                            </tr>
                            <tr>
                                <td><Translation translationKey="delivery_address" /></td>
                                {data.BillingAddress.LocationId > 0 ? <td>{data.BillingAddress.DeliveryAddress}</td> : null}
                                {data.BillingAddress.OtherDeliveryAddressId > 0 ? <td>{data.BillingAddress.OtherDeliveryAddress}</td> : null}
                            </tr>
                        </tbody>
                    </Table>
                    <h5 className="order-detail-location-title"><Translation translationKey="subscription_upper" /></h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="personal_mobile_number" /></td>
                                <td>{data.Subscription.PersonalMobile}</td>
                            </tr>

                            <tr>
                                <td><Translation translationKey="current_vendor" /></td>
                                <td>{data.Subscription.CurrentVendor}</td>
                            </tr>

                            <tr>
                                <td><Translation translationKey="account_number" /></td>
                                <td>{data.Subscription.AccountNumber}</td>
                            </tr>

                            <tr>
                                <td><Translation translationKey="porting_pin_code" /></td>
                                <td>{data.Subscription.PortPinCode}</td>
                            </tr>

                            <tr>
                                <td><Translation translationKey="current_billing_address" /></td>
                                <td>{data.Subscription.CurrentBillingAddress}</td>
                            </tr>

                            <tr>
                                <td><Translation translationKey="vendor" /></td>
                                <td>{data.Subscription.Vendor}</td>
                            </tr>

                            <tr>
                                <td><Translation translationKey="circuit_type" /></td>
                                <td>{data.Subscription.CircuitType}</td>
                            </tr>

                            <tr>
                                <td><Translation translationKey="mobile_service_type" /></td>
                                <td>
                                    <Row>
                                        <Col xs={6} md={6} lg={6}>
                                            {data.Subscription.MobileServiceModel[0].EquipmentModel}
                                        </Col>
                                        <Col xs={6} md={6} lg={6}>
                                            {`${data.Subscription.MobileServiceModel[0].OrderCost} ${data.Subscription.PlanDetails.Currency.CurrencyName}`}

                                        </Col>
                                    </Row>
                                </td>
                            </tr>

                            <tr>
                                <td><Translation translationKey="accessory" /></td>
                                <td>{data.Subscription.PhoneCaseAccessoryDisplay}</td>
                            </tr>

                            <tr>
                                <td><Translation translationKey="plan_name" /></td>
                                <td>{data.Subscription.PlanDetails.PlanName}</td>
                            </tr>

                            <tr>
                                <td><Translation translationKey="plan_component" /></td>
                                <td>
                                    {
                                        data.Subscription.PlanDetails.PlanComponents.map((item, i) => (
                                            <div key={i}>{item.ComponentName}<br /></div>
                                        ))
                                    }
                                </td>
                            </tr>

                            <tr>
                                <td><Translation translationKey="total_order_cost" /></td>
                                <td>{data.Subscription.PlanDetails.TotalCost.toFixed(2)} {data.Subscription.PlanDetails.Currency.CurrencyName}</td>
                            </tr>
                            
                        </tbody>
                    </Table>
                    <h5 className="order-detail-location-title">
                        <Translation translationKey="capital_business_justification" />
                    </h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="purpose_of_use" /></td>
                                <td>{data.BusinessJustification.PurposeOfUse}</td>
                            </tr>

                            <tr>
                                <td><Translation translationKey="business_case" /></td>
                                <td>{data.BusinessJustification.DetailName}</td>
                            </tr>

                            <tr>
                                <td><Translation translationKey="business_justification" /></td>
                                <td>{data.BusinessJustification.BusinessJustification}</td>
                            </tr>

                            <tr>
                                <td><Translation translationKey="additional_information" /></td>
                                <td>{data.BusinessJustification.AdditionalInformation}</td>
                            </tr>

                            <tr>
                                <td><Translation translationKey="term_agreement" /></td>
                                <td>{data.BusinessJustification.TermAgreementDisplay}</td>
                            </tr>
                        </tbody>
                    </Table>
                    {isWireline &&
                        <OrderRequestFiles files={data.Order.OrderFileNames} />
                    }
                </div>
            </div>
        );
    }
}

export default withRouter(PortInDetails)